import { createAsyncThunk } from '@reduxjs/toolkit';

const getParams = (filters, breakdown = null) => {
  const params = {
    filter_by: {
      date: {
        from: filters?.from,
      },
    },
    date_group: filters?.date_group,
    group_by_2: breakdown,
    top_by: 'count',
  };

  if (filters?.to) {
    params['filter_by']['date']['to'] = filters?.to;
  }

  if (filters?.c_to || filters?.c_from) {
    if (filters?.c_to) {
      const compare = {
        date: {
          to: filters?.c_to,
        },
      };
      params['compare'] = compare;
    }
    if (filters?.c_from) {
      const compare = {
        date: {
          from: filters?.c_from,
        },
      };
      params['compare'] = compare;
    }
  }

  if (filters?.recruiter_id?.length) {
    const ids = filters?.recruiter_id?.map((r) => r?.id);
    const condition = filters?.recruiter_id_condition?.id;
    params.filter_by['recruiter_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.flow_id?.length) {
    const ids = filters?.flow_id?.map((r) => r?.id);
    const condition = filters?.flow_id_condition?.id;
    params.filter_by['flow_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.department_id?.length) {
    const ids = filters?.department_id?.map((r) => r?.id);
    const condition = filters?.department_id_condition?.id;
    params.filter_by['ats_department_id'] = {
      [condition]: ids,
    };
  }

  if (filters?.job_id?.length) {
    const ids = filters?.job_id?.map((r) => r?.id);
    const condition = filters?.job_id_condition?.id;
    params.filter_by['ats_job_id'] = {
      [condition]: ids,
    };
  }

  return params;
};

const getRecruiterKpi = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters } = payload;
    const params = getParams(filters);
    const result = await http.post('/reports/flow_kpi', params);
    return result?.data;
  } catch {}
};

export const fetchRecruiterKpi = createAsyncThunk(
  'reportsv2/recruiterkpi',
  getRecruiterKpi
);

const getBreakdown = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters, type = 'recruiter' } = payload;
    const params = getParams(filters, type);
    const result = await http.post('/reports/flow_kpi', params);
    return result?.data;
  } catch {}
};

const getMessageBreakdown = async (payload = {}, { extra: { http } }) => {
  try {
    const { filters, type = 'recruiter' } = payload;
    const params = getParams(filters, type);
    const result = await http.post('/reports/flow_message_kpi', params);
    return result?.data;
  } catch {}
};

export const fetchRecruiterBreakdown = createAsyncThunk(
  'reportsv2/recruiterkpi/breakdown',
  getBreakdown
);

export const fetchDiversityBreakdown = createAsyncThunk(
  'reportsv2/diversitykpi/breakdown',
  getBreakdown
);

export const fetchChannelBreakdown = createAsyncThunk(
  'reportsv2/channel/breakdown',
  getMessageBreakdown
);

export const fetchSenderBreakdown = createAsyncThunk(
  'reportsv2/sender/breakdown',
  getMessageBreakdown
);
